import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const sportsRootInitialState: SportsRootState = {
  favouriteSports: [],
  favouriteLeagues: [],
}

const sportsRootSlice = createSlice({
  name: 'sports-root',
  initialState: sportsRootInitialState,
  reducers: {
    toggleSportsFavourite(state, { payload }: PayloadAction<string>) {
      if (state.favouriteSports.includes(payload)) {
        state.favouriteSports = state.favouriteSports.filter(item => item !== payload)
      } else {
        state.favouriteSports.push(payload)
      }
    },

    toggleLeaguesFavourite(state, { payload }: PayloadAction<string>) {
      if (state.favouriteLeagues.includes(payload)) {
        state.favouriteLeagues = state.favouriteLeagues.filter(item => item !== payload)
      } else {
        state.favouriteLeagues.push(payload)
      }
    },
  },
})

export const { toggleSportsFavourite, toggleLeaguesFavourite } = sportsRootSlice.actions

export default persistReducer(
  {
    key: 'sports-root',
    storage,
    debug: !PRODUCTION,
    whitelist: ['favouriteSports', 'favouriteLeagues'],
  },
  sportsRootSlice.reducer
)

// =====
// Types
// =====

export interface SportsRootState {
  favouriteSports: string[]
  favouriteLeagues: string[]
}
